<!--
 * @Date: 2023-12-14 17:44:32
 * @Author: jm
 * @LastEditTime: 2024-08-06 15:44:54
 * @LastEditors: jm
 * @FilePath: \gamegenialjoycom\src\components\GamesDescribe.vue
 * @Description: 
-->
<template>
  <div class="describe">
    <div class="footer">
      <div class="conBox">
        <p>
          Email：oceanwave@gmail.com
        </p>
        <p>Copyright © 2023 www.oceanwave.top</p>
        <p style="margin-top: -10px;">All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomHeader",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #ffffff !important;
}
.describe {
  width: 1000px;
  margin: 0px auto;
}
.footer {
  width: 890px;
  margin: 83px auto 200px;
  padding: 50px 50px;
  color: #ffffff;
  .conBox {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    p {
      font-size: 40px;
      font-weight: bold;
      line-height: 100px;
    }
  }
}
</style>
